import React from 'react'
import "./deleteAccount.scss"

const DeleteAccount = () => {
  return (
    <div className="deleteConatiner">
            <div className="SidebarContainer">

            </div>
            <div className="account_detailcontainer">
                <h1>Delete Account Page</h1>
            </div>
        </div>
  )
}

export default DeleteAccount